import { createSelector } from 'reselect'

const userId = s => s.app.user.id

export const isLoggedIn = createSelector([userId], userId => !!userId)
